import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService, EventManager } from 'ng-jhipster';

import { ProfileService } from '../profiles/profile.service'; // FIXME barrel doesn't work here
import { JhiLanguageHelper, Principal, LoginModalService, LoginService } from '../../shared';

import { VERSION, DEBUG_INFO_ENABLED } from '../../app.constants';
import {DEFAULT_LOGO_URL} from '../../shared/constants/layout.constants';
import { Subscription } from 'rxjs/Subscription';
import { ModuleName, School, SchoolService} from '../../entities/school';

@Component({
    selector: 'jhi-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: [
        'navbar.scss'
    ]
})
export class NavbarComponent implements OnInit, OnDestroy {

    inProduction: boolean;
    isNavbarCollapsed: boolean;
    languages: any[];
    swaggerEnabled: boolean;
    modalRef: NgbModalRef;
    version: string;
    greeting: string;
    account: any;
    accountLabel: string;
    currentTenantName: string;
    currentUserSubscriber: Subscription;
    accountSubscriber: Subscription;
    colorSubscriber: Subscription;
    color: string;
    currentUserIsStudent: boolean;
    currentUserIsSchoolAdmin: boolean;
    logoUrl: string ;

    // TODO improve showing menu items based on role and module
    recurrentReservationsModuleEnabled: boolean;
    showRecurrentReservationMenuItem: boolean;

    constructor(
        private loginService: LoginService,
        private languageHelper: JhiLanguageHelper,
        private languageService: JhiLanguageService,
        private principal: Principal,
        private loginModalService: LoginModalService,
        private profileService: ProfileService,
        private router: Router,
        private eventManager: EventManager,
        private schoolService: SchoolService
    ) {
        this.version = DEBUG_INFO_ENABLED ? 'v' + VERSION : '';
        this.isNavbarCollapsed = true;
        this.languageService.addLocation('home');
    }

    ngOnInit() {
        this.showRecurrentReservationMenuItem = false;

        this.languageHelper.getAll().then((languages) => {
            this.languages = languages;
        });

        this.profileService.getProfileInfo().subscribe(profileInfo => {
            this.inProduction = profileInfo.inProduction;
            this.swaggerEnabled = profileInfo.swaggerEnabled;
        });

        // we load the labels and other configuration
        this.loadAccountConfig();

        // subscribe to the events
        this.currentUserSubscriber = this.eventManager
                                     .subscribe('authenticationSuccess',
                                     (res) => {
                                        this.showRecurrentReservationMenuItem = false;

                                        this.loadCurrentAccount();
                                        this.collapseNavbar();
                                    });
        this.accountSubscriber = this.eventManager
                                        .subscribe('accountModification',
                                        (res) => this.accountLabel = res.content
                                        );
        this.colorSubscriber = this.eventManager
                                .subscribe('navbarColorModification',
                                (res) =>  this.color = '#' + res.content );
    }

    loadCurrentAccount() {
        this.principal.identity().then((account) => {
            this.account = account;
            this.schoolService.findCurrent()
            .subscribe(school => {
                this.loadAccountConfig(school);
            });
        });
    }

    private loadAccountConfig(school?: School) {
        this.currentTenantName = this.schoolService.getCurrentTenantName();
        this.accountLabel = this.loginService.getAccountLabel();

        this.color = this.schoolService.getColor('navbar');

        this.recurrentReservationsModuleEnabled = this.schoolService.isModuleActiveForCurrentTenant(ModuleName.RECURRENT_RESERVATION);

        if (school && school.logoUrl) {
            this.logoUrl = school.logoUrl;
        } else {
            this.logoUrl = DEFAULT_LOGO_URL;
        }

        this.principal.identity().then((account) => {
            this.principal
            .hasOnlyAuthority('ROLE_USER')
            .then((response) => {
                this.currentUserIsStudent = response;
                if (this.recurrentReservationsModuleEnabled && !this.currentUserIsStudent) {
                    this.showRecurrentReservationMenuItem = true;
                }
            });
        });

        this.principal.identity().then((account) => {
            this.principal
            .hasAnyAuthority(['ROLE_SCHOOL_ADMIN'])
            .then((response) => this.currentUserIsSchoolAdmin = response);
        });
    }

    ngOnDestroy() {
        this.currentUserSubscriber.unsubscribe();
        this.accountSubscriber.unsubscribe();
        this.colorSubscriber.unsubscribe();
    }

    changeLanguage(languageKey: string) {
        this.languageService.changeLanguage(languageKey);
    }

    collapseNavbar() {
        this.isNavbarCollapsed = true;
    }

    isAuthenticated() {
        return this.principal.isAuthenticated();
    }

    login() {
        this.modalRef = this.loginModalService.open();
    }

    logout() {
        // set to default values of the variables used to show or hide menu items
        this.currentTenantName = null;
        this.accountLabel = null;
        this.logoUrl = DEFAULT_LOGO_URL;
        this.color = '#' + SchoolService.DEFAULT_NAVBAR_COLOR;

        this.showRecurrentReservationMenuItem = false;
        this.schoolService.setModuleDeactiveForCurrentTenant(ModuleName.RECURRENT_RESERVATION);

        this.currentUserIsStudent = false;
        this.currentUserIsSchoolAdmin = false;

        this.collapseNavbar();
        this.loginService.logout();
        this.router.navigate(['']);
    }

    toggleNavbar() {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    }

    getImageUrl() {
        return this.isAuthenticated() ? this.principal.getImageUrl() : null;
    }

    onSubmenuToggle(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        const target = event.currentTarget as HTMLElement;
        if (target.parentElement) {
            target.parentElement.classList.toggle('show');
        }

         if (target.nextElementSibling) {
            target.nextElementSibling.classList.toggle('show');
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/navbar/navbar.component.ts